export enum ProductCode {
  K01 = 'K01',
  K02 = 'K02',
  K100 = 'K100',
  K200 = 'K200',
  K300 = 'K300',
  K400 = 'K400',
}
